<template>
  <v-container fluid class="hir px-0" :class="!isMobile ? 'pt-3' : 'pt-0'">
    <top-bar v-if="!isMobile"></top-bar>
    <div class="page-content">
      <div
        class="top-icons w-100"
        :style="
          aktualisProjekt.HeaderFl
            ? !isMobile
              ? 'top: 100px;'
              : 'top: 10px;'
            : !isMobile
            ? 'top: 70px'
            : 'top: 10px;'
        "
      >
        <v-btn icon large color="primary" class="back-btn" @click="goBack">
          <i class="fas fa-chevron-left"></i>
        </v-btn>
        <div class="ml-auto">
          <v-btn
            v-if="isPetKupaMagyar || isPetKupaAngol"
            icon
            large
            color="primary"
            class="fontos-icon font-size-xl mr-3"
            @click="CopyHirUrl"
          >
            <i class="fas fa-link"></i>
          </v-btn>
          <k-fontos-hir-icon
            large
            :hir="hir"
            class="fav-btn primary--text mr-3"
          ></k-fontos-hir-icon>
          <k-hamburger-icon v-if="isMobile"></k-hamburger-icon>
        </div>
      </div>
      <div v-if="!hirLoading">
        <div v-if="hir">
          <div class="card-single-post mb-3">
            <img :src="hir.Kep + '?h=400'" :alt="hir.Cim" />
            <div class="card-single-post-infos">
              <div class="card-single-post-infos-inner">
                <h1 class="mb-3">
                  {{ hir.Cim }}
                </h1>
                <p class="hirismerteto" v-if="hir.VezerHirFl">
                  {{ hir.Ismerteto }}
                </p>
                <div class="card-single-post-author">
                  <v-img
                    :src="
                      hir.Szerzo.Kep
                        ? hir.Szerzo.Kep + '?w=32&h=32'
                        : $placeholderImage
                    "
                    height="32px"
                    max-height="32px"
                    width="32px"
                    max-width="32px"
                    class="rounded"
                  >
                  </v-img>
                  <span class="dot-separator white mx-2"></span>
                  <span>{{ hir.Szerzo.Nev }}</span>
                  <span class="dot-separator white mx-2"></span>
                  <span class="white--text">{{
                    hir.MegjelenesDatuma | toShortDate
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <p class="hirismerteto px-3" v-if="!hir.VezerHirFl">
            {{ hir.Ismerteto }}
          </p>
          <div
            class="ck-content px-3"
            :class="{ 'no-image-shadow': !hir.KepArnyekFl }"
            v-if="hir"
            v-html="hir.Tartalom"
            v-highlightjs
          ></div>
          <div v-if="tovabbiHirek.length > 0" class="px-3 mb-14">
            <v-divider class="primary mb-3"></v-divider>
            <h3 class="primary--text">
              További cikkek ebben a kategóriában
            </h3>
            <k-more-news-list :hirek="tovabbiHirek"></k-more-news-list>
          </div>
        </div>
        <div v-else class="fill-height" :style="contentHeight">
          <k-nodata-info>
            <template v-slot:icon>
              <i class="fas fa-exclamation"></i>
            </template>
            <template v-slot:text>
              {{ nyelvesites['sikertelen_cikk_betoltes_text'] }}
            </template>
          </k-nodata-info>
        </div>
      </div>
      <div v-else>
        <v-progress-circular
          indeterminate
          color="primary"
          class="absolute-center"
        ></v-progress-circular>
      </div>
    </div>
    <div class="text-center mb-11">
      <cikk-admin-link :hirId="hir.Id"></cikk-admin-link>
    </div>
    <input
      class="url-holder-hidden-input"
      ref="url"
      v-model="petKupaHirLink"
      readonly
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { NotificationFunctions } from '../functions/NotificationFunctions';
import { hirService } from '../services/HirService';
import { AppStoreTypes } from '../store/modules/app';
import { Jogosultsag } from '../enums/jogosultsag';

export default {
  name: 'Hir',
  data() {
    return {
      hirLoading: false,
      hir: null,
      tovabbiHirek: [],
      Jogosultsag,
    };
  },
  mounted() {},
  created() {},
  methods: {
    async GetHir() {
      this.hirLoading = true;
      try {
        let hir = null;
        if (this.isAzonosito) {
          hir = await hirService.GetHirByAzonosito({ azonosito: this.hirId });
        } else {
          hir = await hirService.GetHir({ hirId: this.hirId });
        }
        if (hir?.Kategoriak?.length) {
          this.GetTovabbiHirek(hir.Kategoriak[0].Id);
        }
        this.hir = hir;
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.hirLoading = false;
    },
    goBack() {
      this.$store.dispatch(AppStoreTypes.pageTransition.set, {
        value: {
          name: 'router-view-back',
          mode: '',
        },
      });
      if (this.$route.query.fooldalra == 'true') {
        this.$router.push('/fooldal/');
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push('/fooldal/');
      }
    },
    async GetTovabbiHirek(kategoriaId) {
      try {
        let hirek = await hirService.GetHirek({
          kategoriaId: kategoriaId,
          mennyiseg: 4,
        });
        hirek = hirek.filter(x => x.Id != this.hir.Id).slice(0, 3);
        this.tovabbiHirek = hirek;
      } catch (error) {
        this.tovabbiHirek = [];
        console.log(error);
      }
    },
    CopyHirUrl() {
      if (!this.petKupaHirLink) {
        return false;
      }
      var copyText = this.$refs.url;
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      NotificationFunctions.InfoAlert(
        'URL vágólapra másolva.',
        this.petKupaHirLink
      );

      if (window.clipboardData) {
        window.clipboardData.setData('Text', this.petKupaHirLink);
      } else if (navigator) {
        navigator.clipboard.writeText(this.petKupaHirLink);
      }
    },
  },
  computed: {
    ...mapGetters({ user: AppStoreTypes.user.get }),
    hirId() {
      return this.$route.params.id;
    },
    isAzonosito() {
      return isNaN(this.hirId);
    },
    contentHeight() {
      let bottomNavHeight = this.$vuetify.application.bottom;
      //prettier-ignore
      return 'height: 100vh; overflow-y: scroll;';
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    aktualisProjekt() {
      return this.user?.Projekt;
    },
    isPetKupaMagyar() {
      return this.user.Projekt.Id == 15;
    },
    isPetKupaAngol() {
      return this.user.Projekt.Id == 20;
    },
    petKupaHirLink() {
      let hirId = this.hirId;
      if (this.isPetKupaMagyar) {
        return `https://petkupa.hu/hu_HU/?cikkId=${this.hirId}`;
      } else if (this.isPetKupaAngol) {
        return `https://petkupa.hu/eng/?cikkId=${this.hirId}`;
      } else {
        return '';
      }
    },
  },
  watch: {
    hirId: {
      handler: function(v) {
        this.GetHir();
      },
      immediate: true,
    },
  },
};
</script>
